<!-- plan-refuerzo-seguimiento.component.html -->
<div class="modal-header bg-primary text-white">
  <h5 class="modal-title">
    <i class="icofont icofont-tasks-alt me-1"></i>
    Seguimiento plan de refuerzo — {{ nombreColaborador }}
  </h5>
  <button type="button" class="btn-close btn-close-white" (click)="cerrar()"></button>
</div>

<div class="modal-body">
  <div *ngIf="cargando" class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <div *ngIf="!cargando && acciones.length === 0" class="text-center py-4 text-primary">
    <i class="icofont icofont-info-circle fs-4 d-block mb-1"></i>
    No hay acciones de refuerzo registradas para esta evaluación.
  </div>

  <div *ngIf="!cargando">
    <div class="card accion-refuerzo-card mb-3 border-0 shadow-sm" *ngFor="let accion of acciones">
      <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
        [class.expandida]="accionExpandida === accion.id" (click)="toggleAccion(accion)">
        <div class="d-flex align-items-start gap-2">
          <i class="icofont icofont-listine-dots fs-5 mt-1"></i>
          <div>
            <strong>{{ accion.accion }}</strong>
            <div class="small text-secondary">
              <i class="icofont icofont-calendar me-1"></i>Compromiso: {{ accion.fecha_compromiso | date: 'dd/MM/yyyy'
              }}
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="badge rounded-pill" [ngClass]="claseEstadoPlan(accion.estado_plan)">
            {{ descripcionEstadoPlan(accion.estado_plan) }}
          </span>
          <button type="button" class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
            ngbTooltip="Editar acción" (click)="abrirModalAccion(accion, $event)">
            <i class="icofont icofont-pencil"></i>
          </button>
          <i class="icofont fs-5 chevron-icon"
            [ngClass]="accionExpandida === accion.id ? 'icofont-rounded-up' : 'icofont-rounded-down'"></i>
        </div>
      </div>

      <div class="card-body" *ngIf="accionExpandida === accion.id">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0 text-secondary"><i class="icofont icofont-history me-1"></i>Historial de seguimiento</h6>

        </div>

        <div *ngIf="cargandoSeguimientoPorAccion[accion.id]" class="text-center py-3">
          <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        </div>

        <div *ngIf="!cargandoSeguimientoPorAccion[accion.id] && seguimientosPorAccion[accion.id]?.length">
          <div class="table-responsive">
            <table class="table table-bordered table-hover align-middle mb-0" [id]="tablaSeguimientoId(accion.id)">
              <thead class="bg-primary text-white">
                <tr>
                  <th>Fecha</th>
                  <th class="text-center">Cumplido</th>
                  <th>Responsable</th>
                  <th>Observación</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let s of seguimientosPorAccion[accion.id] | paginate: { itemsPerPage: pageSizePorAccion[accion.id] || PAGE_SIZE_DEFAULT, currentPage: paginaPorAccion[accion.id] || 1, id: 'seguimiento_' + accion.id }"
                  [class.table-light]="Number(s.estado) !== 1">
                  <td>{{ s.fecha_seguimiento | date: 'dd/MM/yyyy' }}</td>
                  <td class="text-center">
                    <span class="badge rounded-pill" [ngClass]="s.cumplido ? 'bg-success' : 'bg-secondary'">
                      {{ s.cumplido ? 'SÍ' : 'NO' }}
                    </span>
                  </td>
                  <td>{{ s.ResponsableSeguimientoData?.primernombre ? (s.ResponsableSeguimientoData?.primernombre + ' '
                    + s.ResponsableSeguimientoData?.segundonombre + ' ' + s.ResponsableSeguimientoData?.papellidos + ' '
                    + s.ResponsableSeguimientoData?.seapellidos) : (s.responsable_seguimiento || '-') }}</td>
                  <td>{{ s.observacion || '-' }}</td>
                  <td class="text-center">
                    <span class="badge rounded-pill" [ngClass]="Number(s.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                      {{ Number(s.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                    </span>
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-1">
                      <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                        *ngIf="Number(s.estado) === 1" ngbTooltip="Editar" (click)="abrirModalSeguimiento(accion, s)">
                        <i class="icofont icofont-pencil"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                        *ngIf="Number(s.estado) === 1" ngbTooltip="Inactivar"
                        (click)="inactivarSeguimiento(accion.id, s)">
                        <i class="icofont icofont-close"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                        *ngIf="Number(s.estado) !== 1" ngbTooltip="Activar" (click)="activarSeguimiento(accion.id, s)">
                        <i class="icofont icofont-check"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
            <div class="d-flex align-items-center">
              <label class="me-2 small mb-0">Mostrar:</label>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSizePorAccion[accion.id]"
                (change)="paginaPorAccion[accion.id] = 1">
                <option *ngFor="let size of [5, 10, 20, 50]" [value]="size">{{ size }}</option>
              </select>
            </div>
            <pagination-controls [id]="'seguimiento_' + accion.id" (pageChange)="paginaPorAccion[accion.id] = $event"
              [maxSize]="5" [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
              nextLabel="Siguiente"></pagination-controls>
          </div>

          <div class="btn-showcase text-center mt-3">
            <button class="btn btn-outline-success-2x btn-sm" type="button" ngbTooltip="Exportar a Excel"
              (click)="exportarExcel(accion.id)">
              <i class="icofont icofont-file-excel"></i> EXCEL
            </button>
            <button class="btn btn-outline-danger-2x btn-sm" type="button" ngbTooltip="Exportar a PDF"
              (click)="exportarPDF(accion.id)">
              <i class="icofont icofont-file-pdf"></i> PDF
            </button>
            <button type="button" class="btn btn-sm btn-primary" (click)="abrirModalSeguimiento(accion)">
              <i class="icofont icofont-plus me-1"></i>Nuevo seguimiento
            </button>
          </div>
        </div>

        <div *ngIf="!cargandoSeguimientoPorAccion[accion.id] && !seguimientosPorAccion[accion.id]?.length"
          class="text-center text-secondary py-3">
          <i class="icofont icofont-info-circle me-1"></i>Aún no hay seguimientos registrados.
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cerrar()">Cerrar</button>
</div>